<template>
  <div>
    <div v-if="showType == 'properties'">
      <section-header-v1-properties :formId="formId" />
    </div>
    <fb-text-v1
      v-else
      :showType="showType"
      :properties="properties"
      :id="id"
      :form="form"
      :page="page"
      :componentsIdSuffix="componentsIdSuffix"
      ref="textComponent"
    ></fb-text-v1>
  </div>
</template>

<script>
import SectionHeaderV1Properties from "./SectionHeaderV1Properties.vue";
export default {
  name: "SectionHeaderV1",
  components: { SectionHeaderV1Properties },
  props: ["showType", "properties", "form", "id", "formId", "page", "componentsIdSuffix"],
  methods: {
    getBakedLayout() {
      return this.$refs.textComponent.getBakedLayout();
    }
  }
};
</script>
